var pearl = "/static/8fb8ede71d7c1f36.png";

export { pearl as default };
//# sourceMappingURL=pearl.png.js.map
